export enum SceneKeys {
    PRELOADER = "PRELOADER",
    GAME = "GAME",
    UI = "UI",
    SPLASH = "SPLASH",
}